import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { QUEUE_KEY_HELP } from "./queue-keys";

/** The `?` overlay: every queue shortcut. */
export function KeyboardHelpDialog({ onClose }: { onClose: () => void }) {
  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Keyboard shortcuts</DialogTitle>
          <DialogDescription>
            Keys act on the selection, or on the focused finding when nothing is
            selected. They are ignored while you type.
          </DialogDescription>
        </DialogHeader>
        <dl className="grid grid-cols-[auto_1fr] gap-x-6 gap-y-2">
          {QUEUE_KEY_HELP.map(([keys, what]) => (
            <div key={keys} className="contents">
              <dt>
                <kbd className="rounded-sm border px-1.5 py-0.5 font-mono text-xs">
                  {keys}
                </kbd>
              </dt>
              <dd className="text-sm">{what}</dd>
            </div>
          ))}
        </dl>
      </DialogContent>
    </Dialog>
  );
}
